package team.platforma.multiplatform_material_extension.ui.core.global_style

import androidx.compose.material3.ButtonColors
import androidx.compose.material3.ButtonDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color

object TextButtonColorScheme {
    var containerColor: Color? = null
    var contentColor: Color? = null
    var disabledContainerColor: Color? = null
    var disabledContentColor: Color? = null
}

@Composable
internal fun takeTextButtonColors(): ButtonColors {
    val global = TextButtonColorScheme
    val default = ButtonDefaults.textButtonColors()
    return ButtonDefaults.buttonColors().define(global, default)
}

@Composable
private fun ButtonColors.define(
    global: TextButtonColorScheme,
    default: ButtonColors
): ButtonColors {
    return this.copy(
        containerColor = global.containerColor ?: default.containerColor,
        contentColor = global.contentColor ?: default.contentColor,
        disabledContainerColor = global.disabledContainerColor ?: default.disabledContainerColor,
        disabledContentColor = global.disabledContentColor ?: default.disabledContentColor
    )
}